import { Box, Button } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    AttributeType,
    EntityStatus,
    EntityStepTypes,
} from '../../../constants/constants'
import { useAttributesStepValidation } from '../../../utils/attributeValidations'
import {
    EntityInstancePath,
    setRelationStepData,
    updateActiveEntityStep,
    updateActiveFirstLevelStep,
    updateEntityInstancePath,
    updateEntitySteps,
    updatePath,
    updateStartStep,
} from '../../../redux/slices/entityInstanceSlice'
import { v4 as uuidv4 } from 'uuid'
import { updateLoader } from '../../../redux/slices/loaderSlice'
import {
    // isValidEmail,
    updateValuesForPayload,
} from '../../../utils/EntityAttributesUtils'
import {
    modifingItemInRelation,
    onSaveEntityFields,
} from '../../../services/entityServices'
import { useTranslation } from 'react-i18next'
import { ReactElement } from 'react'

interface StepButtonsProps {
    handleCloseFields: (a: boolean) => void
    handleAddInParentRelation?: (id: string) => void
}
const StepButtons = (props: StepButtonsProps): ReactElement => {
    const { t } = useTranslation()
    const { handleAddInParentRelation, handleCloseFields } = props
    const dispatch = useAppDispatch()
    const { validateSteps } = useAttributesStepValidation()
    const org = useAppSelector((state) => state.org.org)
    const orgId = useAppSelector(
        (state) => state.entityInstance.startStep.orgId,
    )
    const path = useAppSelector((state) => state.entityInstance.path)
    const selectedOrgId = useAppSelector(
        (state) => state.entityInstance.startStep.orgId,
    )
    const selectedTemplateId = useAppSelector(
        (state) => state.entityInstance.startStep.templateId,
    )
    const selectedTemplateName = useAppSelector(
        (state) => state.entityInstance.startStep.templateName,
    )

    const parentTemplateName = useAppSelector(
        (state) => state.entityInstance.startStep.parentTemplateName,
    )
    const entitySteps = useAppSelector(
        (state) => state.entityInstance.entitySteps,
    )
    const activeEntityStep = useAppSelector(
        (state) => state.entityInstance.activeEntityStep,
    )

    const entityAttributeStep = entitySteps?.find(
        (i) => i.stepType === EntityStepTypes.Attributes,
    )

    const IsInstanceReadOnly = useAppSelector(
        (state) => state.entityInstance.readOnly,
    )

    const totalSteps = () => {
        return entitySteps.length
    }

    const isLastStep = () => {
        return activeEntityStep === totalSteps() - 1
    }

    const handleNext = () => {
        let isAttributeStepVaid = true
        let updatedEntitySteps = entitySteps
        if (entityAttributeStep?.stepNo === activeEntityStep + 1) {
            const { isValidate, validatedSteps } = validateSteps(entitySteps)
            isAttributeStepVaid = isValidate
            updatedEntitySteps = validatedSteps
        }

        if (isAttributeStepVaid) {
            dispatch(updateActiveEntityStep(activeEntityStep + 1))
            if (path?.length === 1) {
                dispatch(updateActiveFirstLevelStep(activeEntityStep + 1))
            }
            dispatch(setRelationStepData(activeEntityStep + 1))
        } else {
            dispatch(updateEntitySteps(updatedEntitySteps))
        }
    }
    const handleStartStepNext = () => {
        if (entitySteps.length === 1) {
            const uniqueId = uuidv4()
            const path: EntityInstancePath = {
                pathId: uniqueId,
                pathName: parentTemplateName,
                activeStep: 1,
                orgId: selectedOrgId,
                templateId: selectedTemplateId,
                templateName: selectedTemplateName,
                relationId: selectedTemplateId,
                relationName: selectedTemplateName,
                entityId: '',
                entityName: '',
                parentInstanceId: '',
                parentValues: {},
            }
            dispatch(
                updateEntityInstancePath({
                    path: [path],
                    isFirst: true,
                    hasStartStep: true,
                }),
            )
        } else {
            dispatch(updateActiveEntityStep(activeEntityStep + 1))
        }
        if (path.length === 0) {
            dispatch(updateActiveFirstLevelStep(activeEntityStep + 1))
        }
    }

    // const onClickSaveAsDraft = async () => {
    //     let isValidate = true
    //     let errorCheck = false
    //     const validatedSteps = entitySteps.map((step) => {
    //         if (step.stepType === EntityStepTypes.Attributes) {
    //             const updatedAttributes = step?.attributes?.map((attr) => {
    //                 if (
    //                     attr.required &&
    //                     !attr.hide &&
    //                     !attr.disabled &&
    //                     !errorCheck
    //                 ) {
    //                     errorCheck = true
    //                     if (!attr.value || attr.value.length === 0) {
    //                         isValidate = false
    //                         return {
    //                             ...attr,
    //                             errorMessage: t('fieldRequired'),
    //                         }
    //                     }
    //                 } else if (
    //                     !attr.hide &&
    //                     !attr.disabled &&
    //                     attr.dataType.toLowerCase() === AttributeType.EMAIL
    //                 ) {
    //                     if (attr.value) {
    //                         if (isValidEmail(attr.value)) {
    //                             return {
    //                                 ...attr,
    //                                 ...{ errorMessage: '' },
    //                             }
    //                         } else {
    //                             isValidate = false
    //                             return {
    //                                 ...attr,
    //                                 ...{ errorMessage: t('invalidEmail') },
    //                             }
    //                         }
    //                     } else {
    //                         return {
    //                             ...attr,
    //                             ...{ errorMessage: '' },
    //                         }
    //                     }
    //                 }
    //                 return { ...attr, errorMessage: '' }
    //             })

    //             return { ...step, attributes: updatedAttributes }
    //         } else {
    //             return { ...step }
    //         }
    //     })

    //     if (isValidate) {
    //         onSaveInstance(validatedSteps, EntityStatus.DRAFT)
    //     } else {
    //         dispatch(updateEntitySteps(validatedSteps))
    //     }
    // }

    const onClickSave = () => {
        const { isValidate, validatedSteps } = validateSteps(entitySteps)
        if (isValidate) {
            onSaveInstance(validatedSteps, EntityStatus.ACTIVE)
        } else {
            dispatch(updateEntitySteps(validatedSteps))
        }
    }

    const onSaveInstance = async (stepsData: any, status: string) => {
        dispatch(updateLoader(true))
        let sendData = [...stepsData]

        const templateId = entityAttributeStep?.templateId
        const instanceId = entityAttributeStep?.instanceId || '0'

        const updatedsendData = sendData.map((item: any) => {
            if (item.stepType === EntityStepTypes.Attributes) {
                let updatedFields = JSON.parse(JSON.stringify(item.attributes))
                updatedFields = updateValuesForPayload(updatedFields)

                return {
                    ...item,
                    attributes: updatedFields,
                }
            } else {
                return {
                    ...item,
                }
            }
        })
        const savedInstanceResult = await onSaveEntityFields(
            updatedsendData,
            orgId,
            templateId || '',
            instanceId,
            status,
            org?.id || '',
        )

        if (
            path?.length > 1 &&
            instanceId === '0' &&
            path[path.length - 1].parentInstanceId
        ) {
            const payload = {
                parentInstanceId: path[path.length - 1].parentInstanceId,
                childInstanceId: savedInstanceResult?.payload?.entityId,
                newChildInstanceId: '',
                relationStatus: 'ACTIVE',
                relationName: path[path.length - 1].relationId,
            }

            await modifingItemInRelation(orgId, payload)
        }
        //in preview, when creating Instance it should add to it's parent's relation
        //in facility monitoring, while building is adding need to add it to selected site
        if (handleAddInParentRelation) {
            await handleAddInParentRelation(
                savedInstanceResult?.payload?.entityId || '',
            )
        }

        if (savedInstanceResult.type === 'success') {
            // let deviceRelationAttribute: any = null

            sendData = sendData.map((i) => {
                if (i.stepType === EntityStepTypes.Attributes) {
                    //need to find shipment has dive relation as attribute or not
                    i.attributes = i.attributes.map((attr: any) => {
                        if (
                            attr.dataType.toLowerCase() ===
                            AttributeType.DEVICE_RELATION
                        ) {
                            // deviceRelationAttribute = attr
                            return {
                                ...attr,
                                selectedEntities: attr?.value,
                            }
                        } else {
                            return { ...attr }
                        }
                    })
                    i.instanceId = savedInstanceResult?.payload?.entityId || ''
                    i.status = status
                    return { ...i }
                } else {
                    return { ...i, ...{ disabled: false } }
                }
            })

            let updatedPath = [...path]
            updatedPath = updatedPath.map((p, i) => {
                if (i + 1 === updatedPath.length) {
                    return {
                        ...p,
                        ...{
                            entityId:
                                savedInstanceResult?.payload?.entityId || '',
                            activeStep: activeEntityStep,
                        },
                    }
                } else {
                    return { ...p }
                }
            })
            // if (deviceRelationAttribute) {
            //     //we handleing for single selection only
            //     //TO DO: we need support for multi also in future // need API changes as well

            //     // if (deviceRelationAttribute?.value?.length < 1) {
            //     //     deviceRelationAttribute?.selectedEntities?.forEach(
            //     //         async (item: any) => {
            //     //             const payload = {
            //     //                 parentInstanceId:
            //     //                     savedInstanceResult?.payload?.entityId,
            //     //                 childInstanceId: item?.entityId,
            //     //                 newChildInstanceId: '',
            //     //                 relationStatus: 'DELETED',
            //     //                 relationName:
            //     //                     deviceRelationAttribute?.relationId || '',
            //     //             }
            //     //             await modifingItemInRelation(orgId, payload, false)
            //     //         },
            //     //     )
            //     // } else {
            //     //     deviceRelationAttribute?.value?.forEach(
            //     //         async (item: any) => {
            //     //             const payload = {
            //     //                 parentInstanceId:
            //     //                     savedInstanceResult?.palyload?.entityId,
            //     //                 childInstanceId: item?.entityId,
            //     //                 newChildInstanceId: '',
            //     //                 relationStatus: 'ACTIVE',
            //     //                 relationName:
            //     //                     deviceRelationAttribute?.relationId || '',
            //     //             }
            //     //             await modifingItemInRelation(orgId, payload, false)
            //     //         },
            //     //     )
            //     // }

            //     if (instanceId === '0') {
            //         for (const item of deviceRelationAttribute?.value || []) {
            //             const payload = {
            //                 parentInstanceId:
            //                     savedInstanceResult?.payload?.entityId,
            //                 childInstanceId: item?.entityId,
            //                 newChildInstanceId: '',
            //                 relationStatus: 'ACTIVE',
            //                 relationName:
            //                     deviceRelationAttribute?.relationId || '',
            //             }
            //             await modifingItemInRelation(orgId, payload, false)
            //         }
            //     }
            // }

            dispatch(updateEntitySteps(sendData))

            if (path?.length === 1) {
                dispatch(updateStartStep({ instanceExistingOrgId: orgId }))
            }
            if (isLastStep() && path?.length === 1) {
                setTimeout(() => {
                    handleCloseFields(true)
                }, 1000)
            } else if (isLastStep()) {
                updatedPath = updatedPath.slice(0, updatedPath.length - 1)
                await dispatch(
                    updateEntityInstancePath({
                        path: updatedPath,
                        isFirst: false,
                        hasStartStep: false,
                    }),
                )
            } else {
                await dispatch(updatePath(updatedPath))
            }
        }
        dispatch(updateLoader(false))
    }
    return (
        <Box>
            {entitySteps?.length ? (
                <>
                    {entitySteps[activeEntityStep]?.stepType ===
                    EntityStepTypes.Start_step ? (
                        <Button
                            id="start-step-next"
                            variant="contained"
                            onClick={() => {
                                handleStartStepNext()
                            }}
                            sx={{
                                width: '100px',
                                color: '#fff',
                                fontSize: '12px',
                                padding: '7px 20px',
                            }}
                            disabled={!selectedOrgId && !selectedTemplateId}
                        >
                            {t('next')}
                        </Button>
                    ) : (
                        <>
                            {/* {entityAttributeStep?.status !== 'DRAFT' &&
                            entityAttributeStep?.status !== '' ? (
                                <> </>
                            ) : (
                                <Button
                                    id="save-entity-instance-as-draft"
                                    onClick={() => onClickSaveAsDraft()}
                                    sx={{
                                        fontSize: '12px',
                                        padding: '7px 20px',
                                        marginRight: '15px',
                                    }}
                                    variant="outlined"
                                >
                                    {t('saveAsDraft')}
                                </Button>
                            )} */}
                            {IsInstanceReadOnly ? null : (
                                <Button
                                    id="save-entity-instance"
                                    onClick={() => onClickSave()}
                                    sx={{
                                        fontSize: '12px',
                                        padding: '7px 20px',
                                        marginRight: '15px',
                                    }}
                                    variant="outlined"
                                >
                                    {entityAttributeStep?.status === 'ACTIVE'
                                        ? t('update')
                                        : t('save')}
                                </Button>
                            )}
                            {isLastStep() ? (
                                <></>
                            ) : (
                                <Button
                                    id="next-entity-instance-step"
                                    variant="contained"
                                    onClick={() => {
                                        handleNext()
                                    }}
                                    sx={{
                                        width: '100px',
                                        color: '#fff',
                                        fontSize: '12px',
                                        padding: '7px 20px',
                                    }}
                                    disabled={
                                        entitySteps[activeEntityStep + 1]
                                            ?.disabled
                                    }
                                >
                                    {t('next')}
                                </Button>
                            )}
                        </>
                    )}{' '}
                </>
            ) : null}
        </Box>
    )
}

export default StepButtons
